/* eslint-disable max-lines */
import { useI18n } from '@popety_io/popety-io-lib'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'

import PriceRangeDisplay from './PriceRangeDisplay'

import { EstimationContent } from './EstimationContent'

const EstimatedPrice = () => {
  const { t } = useI18n()

  return (
    <Box sx={{ marginTop: '20px' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography
          variant="h6"
          sx={{
            marginBottom: '4px',
            fontSize: '1.1rem',
            textTransform: 'uppercase',
          }}
        >
          {t('estimate.summary.Estimation du prix')}
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <PriceRangeDisplay />
        </Grid>

        <Grid item xs={12} sm={6} md={8}>
          <EstimationContent />
        </Grid>
      </Grid>
    </Box>
  )
}

export default EstimatedPrice
